module.exports = __webpack_public_path__ + "fonts/green-right-bottom.svg";